import { Component } from '@angular/core';
import moment from 'moment';
import Device from 'src/app/services/device.model';
import DeviceMovementModel from 'src/app/services/deviceMovement.model';
import { DeviceMovementService } from 'src/app/services/deviceMovement.service';
import { LocationStrategy } from '@angular/common';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import { DeviceService } from 'src/app/services/device.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-device-tracking',
  templateUrl: './device-tracking.component.html',
  styleUrls: ['./device-tracking.component.scss']
})
export class DeviceTrackingComponent {
  public devices: Array<Device>;
  public device: Device;
  public deviceMovements: Array<DeviceMovementModel>;
  public dupDeviceMovements: Array<DeviceMovementModel>;
  // pagination sorting
  public currentPageNumber: number = 1;
  public noOfItemsPerPage: number = 20;
  public responseLoader = false;
  public loginPersonType: string;
  public loginUserBusinessName: string;
  public keyword: string;
  public tabledatahideshow: boolean;

  public form: FormGroup;
  public submitButtonDisabled: boolean;
  public isSubmitClicked: boolean;
  public submitted: boolean;

  constructor(public deviceMovementService: DeviceMovementService, public deviceService: DeviceService, public toastr: ToastrService,
    private locationStrategy: LocationStrategy, private previousRouteService: PreviousRouteService, public formBuilder: FormBuilder
  ) {
    this.device = new Device();
    // Initialize the register form with validation
    this.form = this.formBuilder.group({
      deviceField: ['', Validators.required]
    });
  }

  public async ngOnInit() {
    try {
      this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
      // loginperson type details
      this.loginPersonType = localStorage.getItem('loginPersonType');
      this.loginUserBusinessName = localStorage.getItem('loginBusinessName');
      this.devices = await this.deviceService.getAllDevices();
      this.device.serial_number = '';
      this.isSubmitClicked = false;
    } catch (error: any) {
      this.toastr.error(error);
    }
  }

  public get f() {
    return this.form.controls;
  }

  // device tracking details
  public async deviceTracking() {
    this.submitted = true;
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }
    try {
      this.submitted = false;
      this.submitButtonDisabled = true;
      this.responseLoader = true;
      this.tabledatahideshow = false;
      this.isSubmitClicked = false;
      this.device.serial_number = typeof (this.device.serial_number) == 'string' ? this.device.serial_number : this.device.serial_number['serial_number'];
      this.deviceMovements = await this.deviceMovementService.getAllDeviceTrackingBySerialNumber(this.device.serial_number);
      this.dupDeviceMovements = [...this.deviceMovements];
      if (this.deviceMovements.length == 0) {
        this.toastr.info('Data not available');
        this.responseLoader = false;
      } else {
        this.responseLoader = false;
        this.tabledatahideshow = true;
        for (let i = 0; i < this.deviceMovements.length; i++) {
          if (this.deviceMovements[i].date + 'T' + this.deviceMovements[i].time + '.000Z') {
            let dateTime: any = moment(this.deviceMovements[i].date + 'T' + this.deviceMovements[i].time + '.000Z').utc().format('DD-MMM-YYYY hh:mm:ss A');
            this.deviceMovements = JSON.parse(JSON.stringify(this.deviceMovements));
            this.dupDeviceMovements = JSON.parse(JSON.stringify(this.dupDeviceMovements));
            this.deviceMovements[i].date = dateTime;
            this.dupDeviceMovements[i].date = dateTime;
          }
        }
      }
      this.isSubmitClicked = true;
      this.form.markAsPristine(); // optional - clears dirty flags
      this.form.markAsUntouched(); // optional - clears touched state
      this.submitButtonDisabled = false;
    } catch (error: any) {
      this.toastr.error(error);
    }
  }
}
